<template>
  <v-container>
    <v-card outlined>
      <v-card-title>
        <v-layout>
          <v-flex>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-flex>
          <v-flex text-right>
            <v-btn @click="openNewEntityTypeDialog" depressed color="primary">
              Create New Entity Type
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="entityTypes"
        :items-per-page="30"
        class="elevation-0"
        :search="search"
      >
        <template v-slot:item.actions="{ item }">
          <v-icon small class="mr-2" @click="editItem(item)">
            mdi-pencil
          </v-icon>
          <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
        </template>
        <template v-slot:item.createdAt="{ item }">
          <div>
            {{ iMoment(item.createdAt) }}
          </div>
        </template>
      </v-data-table>
    </v-card>
    <new-entity-type-dialog ref="newEntityTypeDialog" />
    <edit-entity-type-dialog :details="editedItem" ref="editEntityTypeDialog" />
    <v-dialog v-model="dialogDelete" width="300">
      <v-card>
        <v-card-title>Are you sure you want to delete this item?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            outlined
            color="error"
            class="text-none subtitle-2"
            @click="dialogDelete = false"
            >Cancel</v-btn
          >
          <v-btn
            color="primary"
            class="text-none subtitle-2"
            text
            @click="deleteItemConfirm"
            >Delete</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import NewEntityTypeDialog from "../components/NewEntityTypeDialog";
import EditEntityTypeDialog from "../components/EditEntityTypeDialog";
import { mapActions, mapState } from "vuex";
import moment from "moment";
export default {
  components: { NewEntityTypeDialog, EditEntityTypeDialog },
  data() {
    return {
      search: "",
      dialogDelete: false,
      itemToDelete: {
        name: "",
        latitude: "",
        longitude: "",
      },
      headers: [
        {
          text: "Name",
          align: "start",
          sortable: true,
          value: "name",
        },
        // { text: "Font Family", value: "fontFamily" },
        // { text: "Font Name", value: "fontName" },
        // { text: "Background Color", value: "backgroundColor" },
        // { text: "Font Color", value: "fontColor" },
        { text: "Created At", value: "createdAt" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      editedItem: {
        name: "",
        latitude: "",
        longitude: "",
      },
      editedIndex: -1,
      defaultItem: {
        name: "",
        latitude: "",
        longitude: "",
      },
    };
  },
  computed: {
    ...mapState("$_home", ["entityTypes"]),
  },
  created() {
    if (this.entityTypes.length === 0) {
      this.getEntityTypes({
        collection: "entityTypes",
        mutation: "updateEntityTypes",
      });
    }
  },
  methods: {
    ...mapActions({
      getEntityTypes: "$_home/getContent",
      deleteEntityType: "$_home/deleteContent",
    }),
    iMoment(timestamp) {
      if (timestamp) {
        let temp = timestamp.seconds * 1000;
        return moment(temp).format("lll");
      } else {
        return 0;
      }
    },
    openNewEntityTypeDialog() {
      this.$refs.newEntityTypeDialog.toggleDialog();
    },
    editItem(item) {
      this.editedIndex = this.entityTypes.indexOf(item);
      this.editedItem = Object.assign({}, this.entityTypes[this.editedIndex]);

      console.log("Edited Item: ", this.editedItem);

      this.$refs.editEntityTypeDialog.toggleDialog(this.editedItem);
    },
    deleteItem(item) {
      this.editedIndex = this.entityTypes.indexOf(item);
      this.itemToDelete = Object.assign({}, this.entityTypes[this.editedIndex]);
      this.dialogDelete = true;

      console.log(item);
    },
    deleteItemConfirm() {
      this.deleteEntityType({
        details: this.itemToDelete,
        collection: "entityTypes",
        type: "Entity Type",
      }).then(() => {
        this.dialogDelete = false;
        this.getEntityTypes({
          collection: "entityTypes",
          mutation: "updateEntityTypes",
        });
      });
    },
  },
};
</script>

<style>
</style>